export const envs = Object.freeze({
  Sandbox: 'SANDBOX',
  Production: 'PRODUCTION'
})

// Free/consumer e-mail providers, as full domains.
export const publicEmailDomains = Object.freeze([
  'aol.com',
  'daum.net',
  'fastmail.com',
  'gmx.com',
  'hey.com',
  'inbox.lv',
  'mail.com',
  'mail.ru',
  'me.com',
  'mac.com',
  'naver.com',
  'pm.me',
  'proton.me',
  'qq.com',
  'rocketmail.com',
  'seznam.cz',
  'sina.com',
  'tuta.io',
  'tutanota.com',
  'web.de',
  'ymail.com',
  'zoho.com',
  '126.com',
  '163.com'
])

// Providers with many country variants (hotmail.co.uk, yahoo.fr, live.se, ...).
// Matched on the first label of the domain, so every TLD is covered.
export const publicEmailProviders = Object.freeze([
  'gmail',
  'googlemail',
  'gmx',
  'hotmail',
  'icloud',
  'live',
  'msn',
  'outlook',
  'protonmail',
  'yahoo',
  'yandex'
])
